<template>
  <div>
    <v-layout class="systock-breadcrump text-uppercase" align-center>
      <v-flex xs5>
        <v-breadcrumbs>
          <v-breadcrumbs-item>
            <h4>
              <v-icon left>mdi-file-import</v-icon>
              Produtos Análise Mercado
            </h4>
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-flex>
    </v-layout>

    <v-card flat>
      <v-tabs centered>
        <v-tab>
          <v-icon left>mdi-align-vertical-bottom</v-icon>
          Análise Mercado
        </v-tab>

        <v-tab-item class="ma-0">
          <Tabela />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import Tabela from './Tabela.vue';

export default {
  name: 'Index',
  components: {
    Tabela
  }
}
</script>

<style>

</style>
